export default Object.freeze({
  Text: 1,
  Image: 2,
  ImageUrl: 3,
  DocumentUrl: 4,
  Audio: 5,
  AudioUrl: 6,
  TaskRun: 7,
  EmailMessage: 8,
  AIThinking: 9,
  Location: 10,
  VideoUrl: 11,
  Contact: 12,
});
